export const cellEditors = {
  TEXT: "TextEditor",
  ENUM: "EnumEditor",
  REF: "RefEditor",
  DATE: "app-date-picker",
  LABEL: "CombinedLabel",
  DECIMAL: "DecimalEditor",
};
